module.exports = __webpack_public_path__ + "img/job_icon.0ff5e5a2.svg";